import React from 'react';

import styles from './AiPhotoGenerationToolbarDelimiter.css';

export const AiPhotoGenerationToolbarDelimiter = () => {
    return <div className={styles.delimiter} />;
};
